<template>
  <div class="group">
    <div class="label">
      URL
    </div>

    <div>
      <a
        :href="quiz.get('url')"
        target="_blank"
        class="url"
        >
        {{ quiz.get('url') }}
      </a>
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    quiz: function () {
      return this.$store.state.quiz.quiz
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_style.scss';
.url {
  word-break: break-all;
}
</style>
